import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'daysToString',
})
export class DaysToStringPipe implements PipeTransform {
  transform(value: number, status = 'due'): string {
    if (value === -999) return 'as soon as NOTICE filed';

    return value === 0
      ? 'on due date'
      : value < 0
      ? `${Math.abs(value)}d before ${status}`
      : `${value}d after ${status}`;
  }
}
